import React from 'react'
import { Wrapper } from './CounterCardStyled'

const CounterCard = props => {
  const { title, counter, icon, onClick, children, bgColor } = props
  return (
    <Wrapper $bgColor={bgColor} onClick={onClick}>
      {children}
      <div className="card-top">
        <div className="card-title">{title}</div>
        <div className="card-icon">
          <img src={icon} alt="" />
        </div>
      </div>
      <div className="card-bottom">
        <div className="card-counter">{counter}</div>
      </div>
    </Wrapper>
  )
}

export default CounterCard
